import React from "react";
import { Navbar, Nav } from "react-bootstrap";

function NavbarComponent() {
  return (
    <div>
      <Navbar className="navbar-bg" expand="lg" fixed="top">
        <Navbar.Brand href="#home" className="logo">
          Ruhi Enterprise
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            <Nav.Link href="#about">Our Product</Nav.Link>
            <Nav.Link href="#about">About Us</Nav.Link>
            <Nav.Link href="#contact">Contact Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

export default NavbarComponent;
